import * as constants from './constants'

export const fetchLocationDetails = locationId => ({
    type: constants.FETCH_LOCATION_DETAILS,
    locationId,
})

export const receivedLocationDetails = details => ({
    type: constants.RECEIVED_LOCATION_DETAILS,
    ...details,
})

export const fetchRates = (criteria, requestId) => ({
    type: constants.FETCH_RATES,
    criteria,
    requestId,
})

export const receivedLocationRates = (rates, requestId) => ({
    type: constants.RECEIVED_LOCATION_RATES,
    ...rates,
    requestId,
})

export const failedToFetchRates = (criteria, requestId, error) => ({
    type: constants.FAILED_TO_FETCH_RATES,
    criteria,
    requestId,
    error,
})

export const fetchRateDetails = (locationId, rateId, beginTime, endTime) => ({
    type: constants.FETCH_RATE_DETAILS,
    locationId,
    rateId,
    beginTime,
    endTime,
})

export const receivedRateDetails = details => ({
    type: constants.RECEIVED_RATE_DETAILS,
    ...details,
})

export const receivedReservationConfirmation = (bookingId, confirmation) => ({
    type: constants.RECEIVED_RESERVATION_CONFIRMATION,
    bookingId,
    ...confirmation,
})

export const saveBookingPass = bookingId => ({
    type: constants.SAVE_BOOKING_PASS,
    bookingId,
})

export const getReservations = (offset, limit, status = 'ACTIVE', requestId) => ({
    type: constants.GET_RESERVATIONS,
    offset,
    limit,
    status,
    requestId,
})

export const receivedReservations = (reservations, requestId) => ({
    type: constants.RECEIVED_RESERVATIONS,
    ...reservations,
    requestId,
})

export const setAutoRenew = (reservation, autoRenew) => ({
    type: constants.SET_AUTO_RENEW,
    reservation,
    autoRenew,
})

export const updatedAutoRenew = reservation => ({
    type: constants.UPDATED_AUTO_RENEW,
    ...reservation,
})

export const getReservationCancelAmendPolicy = reservationId => ({
    type: constants.GET_RESERVATION_CANCEL_AMEND_POLICY,
    reservationId,
})

export const reservationCancelAmendPolicyResponse = response => ({
    type: constants.RESERVATION_CANCEL_AMEND_POLICY_RESPONSE,
    response,
})

export const cancelReservation = reservationId => ({
    type: constants.CANCEL_RESERVATION,
    reservationId,
})

export const cancelReservationResponse = response => ({
    type: constants.CANCEL_RESERVATION_RESPONSE,
    response,
})

export const changeVehicle = (reservationId, selectedVehicles) => ({
    type: constants.CHANGE_VEHICLE,
    reservationId,
    selectedVehicles,
})

export const getReservationReceipt = (reservationId, receiptTab) => ({
    type: constants.GET_RESERVATION_RECEIPT,
    reservationId,
    receiptTab,
})

export const changeVehicleResponse = response => ({
    type: constants.CHANGE_VEHICLE_RESPONSE,
    response,
})

export const validateWaitingListKey = waitingListKey => ({
    type: constants.VALIDATE_WAITING_LIST_KEY,
    waitingListKey,
})

export const validatedWaitingListKey = (waitingListKey, response) => ({
    type: constants.VALIDATED_WAITING_LIST_KEY,
    waitingListKey,
    response,
})

export const failedToValidateWaitingListKey = waitingListKey => ({
    type: constants.FAILED_TO_VALIDATE_WAITING_LIST_KEY,
    waitingListKey,
})

export const addToWaitingList = (rate, grsId) => ({
    type: constants.ADD_TO_WAITING_LIST,
    rate,
    grsId,
})

export const addedToWaitingList = response => ({
    type: constants.ADDED_TO_WAITING_LIST,
    response,
})

export const cancelWaitingList = waitingListKey => ({
    type: constants.CANCEL_WAITING_LIST,
    waitingListKey,
})

export const canceledWaitingList = waitingListKey => ({
    type: constants.CANCELED_WAITING_LIST,
    waitingListKey,
})

export const getSeasonTickets = locationId => ({
    type: constants.GET_SEASON_TICKETS,
    locationId,
})
export const receivedSeasonTickets = seasonTickets => ({
    type: constants.RECEIVED_SEASON_TICKETS,
    seasonTickets,
})
export const receivedSeasonTicketRates = seasonTickets => ({
    type: constants.RECEIVED_SEASON_TICKETS_RATES,
    seasonTickets,
})
